module.exports = __webpack_public_path__ + "static/img/cover_p7.c51b3e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/CustomersInfo/cover_p7.png
// module id = BxAg
// module chunks = 19